// Overview.jsx
import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col, Button, ListGroup, ListGroupItem } from 'reactstrap';
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import { useNavigate } from "react-router-dom";
import axios from 'axios';

import { 
    //approvePreRegistration as onApprovePreRegistration, 
    //rejectPreRegistration as onRejectPreRegistration,
    addNewRegistration as onAddNewRegistration,
    addNewNote as onAddNewNote,
    getStudyLevels as onGetStudyLevels,
    getAcademicYears as onGetAcademicYears,
     getActiveAcademicYears as onGetActiveAcademicYears,

    
} from "store/actions";

//import { RESET_PRE_REGISTRATION_ACTION } from "store/pre-registrations/actionTypes";
import RegistrationModal from "./RegistrationModal"; 
import NotationModal from "./NotationModal"; 

const Overview = ({
    preRegistration,
    student,
    //studyLevels = [],
    //students = []
}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    //const { actionSuccess } = useSelector(state => state.preRegistrationReducer);

    const [registrationModalOpen, setRegistrationModalOpen] = useState(false);
    const [notationModalOpen, setNotationModalOpen] = useState(false);




    const [modal, setModal] = useState(false);
    const toggle = () => setModal(prev => !prev);

    const [loadingSubmit, setLoadingSubmit] = useState(false);



    // Selector study levels
    const StudyLevelProperties = createSelector(
        (state) => state.studyLevelReducer, 
        (studyLevelReducer) => ({
            studyLevels: studyLevelReducer.studyLevels,
            loading: studyLevelReducer.loading,
            
        })
    );

    const {studyLevels} = useSelector(StudyLevelProperties);




    // Selector academic year
    /*const AcademicYearProperties = createSelector(
        (state) => state.academicYearReducer, 
        (academicYearReducer) => ({
            academicYears: academicYearReducer.academicYears,
            loading: academicYearReducer.loading,
            
        })
    );

    const {academicYears} = useSelector(AcademicYearProperties);
    */

    const AcademicYearProperties = createSelector(
        (state) => state.academicYearReducer || {}, 
        (academicYearReducer) => ({
            academicYears: academicYearReducer.academicYears || [],
            activeAcademicYears: academicYearReducer.activeAcademicYears || [], // Ajouté ici pour la cohérence
            loading: academicYearReducer.loading,
        })
    );

    // Extraction des données
    const { academicYears, activeAcademicYears } = useSelector(AcademicYearProperties);


  
    

    // Selector Registration
    const RegistrationProperties = createSelector(
        (state) => state.registrationReducer,
        (registrationReducer) => ({
            success: registrationReducer.success,
            loading: registrationReducer.loading,
            error: registrationReducer.error,
        })
    );
    const { success, loading, error } = useSelector(RegistrationProperties);

    
    // Chargement initial des données au montage du composant
    useEffect(() => {
        dispatch(onGetStudyLevels());
        dispatch(onGetAcademicYears());
        dispatch(onGetActiveAcademicYears());
    }, [dispatch]); // Seul dispatch est nécessaire ici

    // Chargement initial des données
    /*
    useEffect(() => {
        if (!studyLevels.length) dispatch(onGetStudyLevels());
        if (!academicYears.length) dispatch(onGetAcademicYears());
        if (!activeAcademicYears.length) dispatch(onGetActiveAcademicYears());
       
    }, [dispatch, studyLevels.length, academicYears.length, activeAcademicYears.length]);

    */


    /*
    useEffect(() => {
        if (success) {
            toggle();
        }
    }, [success]);
    */

    useEffect(() => {
    // On ne ferme le modal que si l'inscription est un succès ET que le modal est actuellement ouvert !
    if (success && modal) {
        toggle();
        // Optionnel mais recommandé : si tu as une action Redux pour réinitialiser le reducer (ex: resetRegistration()) :
        // dispatch(onResetRegistration());
    }
}, [success, modal]); // Ajout de 'modal' dans les dépendances  


    // Liste des actions
    const studentActions = [
        { label: "Inscription", key: "registration" },
        //{ label: "Notation", key: "notation" },
        { label: "Transfert", key: "transfer" },
        { label: "Demande de documents", key: "documents_request" },
        { label: "Stage", key: "internship" }
    ];

  

    /*
    const handleActionClick = (actionKey) => {
        switch(actionKey) {
            case "registration":
                //toggleRegistrationModal();
                toggle()
                break;
            case "notation":
                toggleNotationModal();
                break;
            default:
                break;
        }
    }
        */

    const handleActionClick = (actionKey) => {
    switch(actionKey) {
        case "registration":
            // Si les niveaux ou les années actives ne sont pas encore chargés, on évite le bug
            if (!studyLevels.length || !activeAcademicYears.length) {
                console.warn("Données en cours de chargement, veuillez patienter...");
                return; 
            }
            toggle();
            break;
        case "notation":
            toggleNotationModal();
            break;
        default:
            break;
    }
};



    // Fonction de soumission du formulaire
    const handleRegistrationSubmitOLD = (values) => {
        const payload = {
            student_id: student?.id,
            academic_year_id: Number(values.academic_year_id),
            study_level_id: Number(values.study_level_id),
            banch_id: Number(values.branch_id),
        };

        dispatch(onAddNewRegistration(payload));
    };

    const handleRegistrationSubmit = (values) => {
        // 1. Trouver l'objet niveau d'étude sélectionné pour récupérer sa branche
        const selectedLevel = studyLevels.find(
            (level) => level.id.toString() === values.study_level_id.toString()
        );

        // 2. Construire le payload final pour l'API
        const payload = {
            student_id: student?.id,
            academic_year_id: Number(values.academic_year_id),
            study_level_id: Number(values.study_level_id),
            // On récupère le branch_id depuis l'objet trouvé (nommé selon ton API)
            branch_id: selectedLevel ? Number(selectedLevel.branch_id) : null,
        };

        dispatch(onAddNewRegistration(payload));
    };


    // Fonction de soumission du formulaire
    const handleNotationSubmit = (values) => {
        const payload = {
            student_id: student?.id,
            academic_year_id: Number(values.academic_year_id),
            study_level_id: Number(values.study_level_id),
        };

        dispatch(onAddNewNote(payload));
    };

    const toggleRegistrationModal = () => setRegistrationModalOpen(prev => !prev);
    const toggleNotationModal = () => setNotationModalOpen(prev => !prev);



    return (
        <>
            <Col xl={3}>
                <Card>
                    <CardBody>
                        <h5 className="fw-semibold">Actions disponibles</h5>
                        {/*
                        <ListGroup flush>
                            {studentActions.map(action => (
                                <ListGroupItem
                                    key={action.key}
                                    tag="button"
                                    action
                                    onClick={() => handleActionClick(action.key)}
                                    className="text-start"
                                >
                                    {action.label}
                                </ListGroupItem>
                            ))}
                        </ListGroup>
                        */}

                        <ListGroup flush>
                        {/* Action : Inscription */}
                        <ListGroupItem
                            tag="button"
                            action
                            disabled={!studyLevels.length || !activeAcademicYears.length}
                            onClick={() => handleActionClick("registration")}
                            className="text-start d-flex justify-content-between align-items-center"
                        >
                            <span>Inscription</span>
                            {(!studyLevels.length || !activeAcademicYears.length) && (
                                <span className="spinner-border spinner-border-sm text-primary" role="status" />
                            )}
                        </ListGroupItem>

                        {/* Action : Transfert */}
                        <ListGroupItem
                            tag="button"
                            action
                            onClick={() => handleActionClick("transfer")}
                            className="text-start"
                        >
                            Transfert
                        </ListGroupItem>

                        {/* Action : Demande de documents */}
                        <ListGroupItem
                            tag="button"
                            action
                            onClick={() => handleActionClick("documents_request")}
                            className="text-start"
                        >
                            Demande de documents
                        </ListGroupItem>

                        {/* Action : Stage */}
                        <ListGroupItem
                            tag="button"
                            action
                            onClick={() => handleActionClick("internship")}
                            className="text-start"
                        >
                            Stage
                        </ListGroupItem>
                    </ListGroup>

                        

                        
                    </CardBody>
                </Card>
            </Col>

            {/* Modal d'inscription 
            <RegistrationModal
                modal={modal}
                toggle={toggle}
                onSubmit={handleRegistrationSubmit}
                academicYears={academicYears || []}
                studyLevels={studyLevels || []}
                //students={studentsForModal}
                currentStudentId={preRegistration?.id}
                isEdit={false}
            />*/}

            <RegistrationModal
                modal={modal}
                toggle={toggle}
                //modal={registrationModalOpen}
                //toggle={toggleRegistrationModal}
                onSubmit={handleRegistrationSubmit}
                academicYears={activeAcademicYears || []}
                studyLevels={studyLevels || []}
                //currentStudentId={student?.id}
                isEdit={false}
                loading={loading}
            />

            <NotationModal
                modal={notationModalOpen}
                toggle={toggleNotationModal}
                onSubmit={handleNotationSubmit}
                academicYears={academicYears || []}
                studyLevels={studyLevels || []}
                isEdit={false}
                loading={loading}
            />

        </>
    );
};

export default Overview;
